import React from "react";
import FacebookIcon from "../Icon/FacebookIcon";
import GithubIcon from "../Icon/GithubIcon";
import TwitterIcon from "../Icon/TwitterIcon";
import Particle from "../Particle";

const Home = () => {
  return (
    <>
      <Particle></Particle>
      
      <div class="hero min-h-screen bg-base-200">
  <div class="hero-content text-center">
    <div class="">
      <h1 class="text-5xl font-bold text-white">Hi, I am <span className="text-primary">Saiful Islam.</span></h1>
      <p class="py-6 text-secondary text-2xl">I am a Junior frontend web developer. I can provide clean code and
              pixel perfect design.
              <br /> I also make website more & more interactive with web
              animations.</p>
              <div className=" md:w-96 mx-auto flex justify-center justify-items-center">
              <FacebookIcon></FacebookIcon>
              <TwitterIcon></TwitterIcon>
              <GithubIcon></GithubIcon>
            </div>
    </div>
  </div>
</div>
    </>
  );
};

export default Home;
